/**
 * Firebase email-action (password reset / verify / recover) helpers.
 * Vue-free so the login page and tests can share the same parsing.
 */

const AUTH_ACTION_MODES = {
  resetPassword: "resetPassword",
  recoverEmail: "recoverEmail",
  verifyEmail: "verifyEmail",
};

const ALLOWED_CONTINUE_HOSTS = [
  "manage.everhost.io",
  "everhost.io",
  "www.everhost.io",
  "localhost",
];

function parseAuthActionQuery(query) {
  const q = query || {};
  const mode = String(q.mode || "").trim();
  const oobCode = String(q.oobCode || q.oobcode || "").trim();
  return {
    mode: mode,
    oobCode: oobCode,
    continueUrl: String(q.continueUrl || "").trim(),
    apiKey: String(q.apiKey || "").trim(),
    lang: String(q.lang || "").trim(),
    isAuthAction: Boolean(mode && oobCode),
  };
}

function isAllowedContinueUrl(url) {
  if (!url) {
    return false;
  }
  try {
    const parsed = new URL(url);
    const host = parsed.hostname.toLowerCase();
    if (ALLOWED_CONTINUE_HOSTS.indexOf(host) !== -1) {
      return parsed.protocol === "https:" || host === "localhost";
    }
    return host.endsWith(".everhost.io") && parsed.protocol === "https:";
  } catch (error) {
    return false;
  }
}

function authActionErrorMessage(error, mode) {
  const code = String((error && (error.code || error.message)) || "");
  const expired =
    code.indexOf("expired-action-code") !== -1 ||
    code.indexOf("invalid-action-code") !== -1 ||
    code.indexOf("INVALID_OOB_CODE") !== -1 ||
    code.indexOf("EXPIRED_OOB_CODE") !== -1;

  if (expired) {
    if (mode === AUTH_ACTION_MODES.verifyEmail) {
      return "This email verification link has expired or has already been used. Sign in and request a new verification email.";
    }
    if (mode === AUTH_ACTION_MODES.recoverEmail) {
      return "This email recovery link has expired or has already been used.";
    }
    return "This password reset link has expired or has already been used. Request a new one from the login page.";
  }

  if (code.indexOf("weak-password") !== -1) {
    return "Choose a stronger password (at least 6 characters).";
  }

  return (error && error.message) || "Something went wrong. Please try again.";
}

const authAction = {
  AUTH_ACTION_MODES: AUTH_ACTION_MODES,
  ALLOWED_CONTINUE_HOSTS: ALLOWED_CONTINUE_HOSTS,
  parseAuthActionQuery: parseAuthActionQuery,
  isAllowedContinueUrl: isAllowedContinueUrl,
  authActionErrorMessage: authActionErrorMessage,
};

module.exports = authAction;
